module.exports = __webpack_public_path__ + "static/media/cafe24-body-1-1.bda18e26.png";